import { interfaceLanguages } from '../countries';

const dictionary = interfaceLanguages.reduce((acc, lang) => {
    acc[lang] = require(`./languages/${lang}.json`);
    return acc;
}, {});

export default dictionary;



// WEBPACK FOOTER //
// ./src/data/dictionary.js